import React, { lazy, Suspense } from 'react';
import { Skeleton, Box, Dialog, DialogContent, DialogTitle } from '@mui/material';
import DashPage from '../dash/DashPage';
import { ReleaseFlag, useReleaseManagement } from '@/utility/feature-management';

const ExpressCheckOutV1 = lazy(() => import("./expressCheckOutV1"));
const ExpressCheckOutV2 = lazy(() => import("./ExpressCheckOutV2"));

const ExpressCheckOut = () => {
    const isExpressCheckoutV2Released = useReleaseManagement(ReleaseFlag.releaseExpressCheckoutV2);

    return (
        <DashPage>
            <Suspense fallback={
                <Dialog open={true} maxWidth="md" fullWidth>
                    <DialogTitle>
                        <Skeleton variant="text" width="60%" height={32} />
                    </DialogTitle>
                    <DialogContent>
                        <Skeleton variant="text" width="40%" height={24} sx={{ mb: 2 }} />
                        <Box sx={{ height: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
                            <Skeleton variant="text" width="80%" />
                            <Skeleton variant="text" width="60%" />
                            <Skeleton variant="text" width="70%" />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
                            <Skeleton variant="rectangular" width={80} height={36} />
                            <Skeleton variant="rectangular" width={80} height={36} />
                        </Box>
                    </DialogContent>
                </Dialog>
            }>
                {isExpressCheckoutV2Released ? <ExpressCheckOutV2 /> : <ExpressCheckOutV1 />}
            </Suspense>
        </DashPage>
    );
};

export default ExpressCheckOut;